import type { SVGProps } from "react";

const SvgPharadayLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
    <g clipPath="url(#clip0_852_11113)">
      <path
        d="M0 8.03113C0 3.63484 3.5639 0.0709343 7.9602 0.0709343H31.8408C36.2371 0.0709343 39.801 3.63484 39.801 8.03113V31.9117C39.801 36.308 36.2371 39.8719 31.8408 39.8719H7.9602C3.5639 39.8719 0 36.308 0 31.9117V8.03113Z"
        fill="#E4DFFF"
      />
      <path
        d="M17.1976 23.3626L8.14002 20.7859C7.67737 20.6543 7.67569 19.9902 8.13773 19.8828L22.3772 16.574C22.4521 16.5567 22.5305 16.5587 22.6055 16.58L31.658 19.1551C32.1206 19.2867 32.1224 19.9508 31.6604 20.0582L17.4259 23.3686C17.3511 23.386 17.2726 23.3839 17.1976 23.3626Z"
        fill="#460993"
      />
      <path
        d="M8.14089 20.7867C7.79228 20.6875 7.67439 20.2436 7.93099 19.9963L24.3402 4.17868C24.6962 3.83549 25.2764 4.24312 25.0909 4.70614L17.7236 23.096C17.6378 23.3102 17.4066 23.4226 17.1828 23.359L8.14089 20.7867Z"
        fill="url(#paint0_linear_852_11113)"
      />
      <path
        d="M31.6607 19.1561C32.0093 19.2553 32.1272 19.6992 31.8706 19.9466L15.4615 35.7642C15.1054 36.1074 14.5253 35.6997 14.7108 35.2367L22.078 16.8469C22.1638 16.6326 22.395 16.5202 22.6188 16.5839L31.6607 19.1561Z"
        fill="url(#paint1_linear_852_11113)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_852_11113"
        x1="11.5747"
        y1="1.76108"
        x2="18.5308"
        y2="39.9682"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5333FC" />
        <stop offset="1" stopColor="#D376FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_852_11113"
        x1="11.5747"
        y1="1.76108"
        x2="18.5308"
        y2="39.9682"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5333FC" />
        <stop offset="1" stopColor="#D376FF" />
      </linearGradient>
      <clipPath id="clip0_852_11113">
        <rect y="0.0709343" width="39.801" height="39.801" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPharadayLogo;
